<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  current: { type: Number, required: true },
  max: { type: Number, required: true },
});

const { t } = useI18n();

const percent = computed(() => {
  if (!props.max) return 0;
  return Math.min(100, Math.round((props.current / props.max) * 100));
});
</script>

<template>
  <div>
    <div class="h-4 w-full bg-n-slate-4">
      <div class="h-4 bg-n-brand" :style="{ width: `${percent}%` }" />
    </div>
    <p class="mt-2 text-center text-sm uppercase tracking-wide text-n-slate-11">
      {{ current }} {{ t('REPORT_DASHBOARD.OPERATIONAL.CLIENTS_WAITING') }}
    </p>
  </div>
</template>
